/* eslint-disable no-prototype-builtins */ // Copyright 2019 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/** @module common-sk/modules/query
 *  @descripiton Utilities for working with URL query strings.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fromParamSet: function() {
        return fromParamSet;
    },
    toParamSet: function() {
        return toParamSet;
    },
    fromObject: function() {
        return fromObject;
    },
    toObject: function() {
        return toObject;
    },
    splitAmp: function() {
        return splitAmp;
    }
});
function fromParamSet(o) {
    if (!o) {
        return '';
    }
    const ret = [];
    const keys = Object.keys(o).sort();
    keys.forEach((key)=>{
        o[key].forEach((value)=>{
            if (Array.isArray(value)) {
                value.forEach((element)=>{
                    ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(element)}`);
                });
            } else {
                ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
        });
    });
    return ret.join('&');
}
function toParamSet(s) {
    s = s || '';
    const ret = {};
    const vars = s.split('&');
    for (const v of vars){
        const pair = v.split('=', 2);
        if (pair.length === 2) {
            const key = decodeURIComponent(pair[0]);
            const value = decodeURIComponent(pair[1]);
            if (ret.hasOwnProperty(key)) {
                ret[key].push(value);
            } else {
                ret[key] = [
                    value
                ];
            }
        }
    }
    return ret;
}
function fromObject(o) {
    const ret = [];
    Object.keys(o).sort().forEach((key)=>{
        const value = o[key];
        if (Array.isArray(value)) {
            value.forEach((v)=>{
                ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
            });
        } else if (typeof value === 'object') {
            ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(fromObject(value))}`);
        } else {
            ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    });
    return ret.join('&');
}
function toObject(s, target) {
    target = target || {};
    const ret = {};
    const vars = s.split('&');
    for (const v of vars){
        const pair = v.split('=', 2);
        if (pair.length === 2) {
            const key = decodeURIComponent(pair[0]);
            const value = decodeURIComponent(pair[1]);
            if (target.hasOwnProperty(key)) {
                const targetValue = target[key];
                switch(typeof targetValue){
                    case 'boolean':
                        ret[key] = value === 'true';
                        break;
                    case 'number':
                        ret[key] = Number(value);
                        break;
                    case 'object':
                        if (Array.isArray(targetValue)) {
                            const r = ret[key] || [];
                            r.push(value);
                            ret[key] = r;
                        } else {
                            ret[key] = toObject(value, targetValue);
                        }
                        break;
                    case 'string':
                        ret[key] = value;
                        break;
                    default:
                        ret[key] = value;
                }
            } else {
                ret[key] = value;
            }
        }
    }
    return ret;
}
function splitAmp(queryStr = '', separator = '\n') {
    return queryStr.split('&').join(separator);
}
